import { Component, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AbstractComponent, Channel, ChannelService, ChannelTypeEnum } from 'lib-trend-core';
import { takeUntil } from 'rxjs';

@Component({
    selector: 'app-campaign-templates',
    templateUrl: './campaign-templates.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CampaignTemplatesComponent extends AbstractComponent implements OnInit {
  channels: Array<Channel> = [];
  selectedChannel: Channel | null = null;

  constructor(
    injector: Injector,
    private readonly channelService: ChannelService,
  ) {
    super(injector);
    this.loadingContent = true;
  }

  ngOnInit(): void {
    this.loadChannels();
  }

  private loadChannels(): void {
    this.channelService.getList()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (channels) => {
          this.channels = (channels ?? []).filter((channel) => channel.type === ChannelTypeEnum.CLOUD_API);
          this.selectedChannel = this.channels.length === 1 ? this.channels[0] : null;
          this.loadingContent = false;
        },
        error: (err) => {
          this.loadingContent = false;
          this.alertService.error(err?.error?.message);
        },
      });
  }

  selectChannel(idChannel: string): void {
    this.selectedChannel = this.channels.find((channel) => channel._id === idChannel) ?? null;
  }
}
